import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.canShareTwin ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c(VBtn, {
    class: 'v-btn-x ml-1 mr-1 v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.title'),
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.showSharingDialog = true;
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-share-alt")])], 1), _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.showSharingDialog,
      "width": "80%",
      "max-width": "850"
    },
    on: {
      "close": function ($event) {
        _vm.showSharingDialog = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.share.title')))];
      },
      proxy: true
    }], null, false, 4278259955)
  }, [_c(VRow, {
    staticClass: "share-dialog",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('p'), _vm.isLoadingShareKeyRequest ? [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.loading')) + "\n      ")] : _vm.existingSharingKey ? [_c('div', {
    staticClass: "w-full mb-3"
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "11",
      "sm": "12",
      "md": "11"
    }
  }, [_c('p', {
    staticClass: "d-flex align-center mb-0 h-full"
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "left": ""
    }
  }, [_vm._v("fal fa-chart-pie")]), _c('span', {
    staticClass: "font-weight-medium"
  }, [_vm._v(_vm._s(_vm.dashboardLink))])], 1)]), _c(VCol, {
    attrs: {
      "cols": "1",
      "sm": "12",
      "md": "1"
    }
  }, [_c(VBtn, {
    class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.copyToClipboard'),
      "icon": "",
      "info": "",
      "fab": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.copyToClipboard($event, _vm.dashboardLink);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-copy")])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "w-full mb-5"
  }, [_c('p', {
    staticClass: "mb-0 pb-1"
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "small": "",
      "left": ""
    }
  }, [_vm._v("fal fa-code")]), _vm._v("\n            HTML\n          ")], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "11",
      "sm": "12",
      "md": "11"
    }
  }, [_c('codemirror', {
    ref: "codemirror",
    staticClass: "elevation-3",
    attrs: {
      "value": _vm.dashboardIframeCode,
      "options": _vm.cmOptions,
      "viewportMargin": Infinity
    },
    on: {
      "focus": _vm.onCmFocus
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "1",
      "sm": "12",
      "md": "1"
    }
  }, [_c(VBtn, {
    class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.copyToClipboard'),
      "icon": "",
      "info": "",
      "fab": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.copyToClipboard($event, _vm.dashboardIframeCode);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-copy")])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "mb-3 w-full"
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "11",
      "sm": "12",
      "md": "11"
    }
  }, [_c('p', {
    staticClass: "mb-0 h-full"
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "left": ""
    }
  }, [_vm._v("fal fa-map-marked-alt")]), _c('span', {
    staticClass: "font-weight-medium"
  }, [_vm._v(_vm._s(_vm.mapLink))])], 1)]), _c(VCol, {
    attrs: {
      "cols": "1",
      "sm": "12",
      "md": "1"
    }
  }, [_c(VBtn, {
    class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.copyToClipboard'),
      "icon": "",
      "info": "",
      "fab": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.copyToClipboard($event, _vm.mapLink);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-copy")])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "w-full mb-5"
  }, [_c('p', {
    staticClass: "mb-0 pb-1"
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "small": "",
      "left": ""
    }
  }, [_vm._v("fal fa-code")]), _vm._v("\n            HTML\n          ")], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "11",
      "sm": "12",
      "md": "11"
    }
  }, [_c('codemirror', {
    ref: "codemirror",
    staticClass: "elevation-3",
    attrs: {
      "value": _vm.mapIframeCode,
      "options": _vm.cmOptions,
      "viewportMargin": Infinity
    },
    on: {
      "focus": _vm.onCmFocus
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "1",
      "sm": "12",
      "md": "1"
    }
  }, [_c(VBtn, {
    class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.copyToClipboard'),
      "icon": "",
      "info": "",
      "fab": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.copyToClipboard($event, _vm.mapIframeCode);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-copy")])], 1)], 1)], 1)], 1), _c(VExpansionPanels, {
    staticClass: "my-4",
    attrs: {
      "value": null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("URL Parameters")])]), _c(VExpansionPanelContent, [_c('ul', [_c('li', [_c('code', [_vm._v("mapstyle=" + _vm._s(_vm.urlParams.mapStyleSelect))]), _vm._v("\n                   \n                  "), _c('div', {
    staticClass: "mt-1 mb-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParams.mapstyle'))
    }
  }), _c(VSelect, {
    attrs: {
      "items": _vm.urlParams.mapStyleItems,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.mapstyle'),
      "outlined": "",
      "item-text": "text",
      "item-value": "value",
      "color": _vm.color
    },
    model: {
      value: _vm.urlParams.mapStyleSelect,
      callback: function ($$v) {
        _vm.$set(_vm.urlParams, "mapStyleSelect", $$v);
      },
      expression: "urlParams.mapStyleSelect"
    }
  })], 1), _c('li', [_c('code', [_vm._v("markerstyle=" + _vm._s(_vm.urlParams.markerStyleSelect))]), _vm._v("\n                   \n                  "), _c('div', {
    staticClass: "mt-1 mb-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParams.markerstyle'))
    }
  }), _c(VSelect, {
    attrs: {
      "items": _vm.urlParams.markerStyleItems,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.markerstyle'),
      "outlined": "",
      "item-text": "text",
      "item-value": "value",
      "color": _vm.color
    },
    model: {
      value: _vm.urlParams.markerStyleSelect,
      callback: function ($$v) {
        _vm.$set(_vm.urlParams, "markerStyleSelect", $$v);
      },
      expression: "urlParams.markerStyleSelect"
    }
  })], 1), _c('li', [_c('code', [_vm._v("hidebar=" + _vm._s(_vm.urlParams.hidebarSwitch))]), _vm._v("\n                   \n                  "), _c('div', {
    staticClass: "mt-1 mb-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParams.hidebar'))
    }
  }), _c(VSwitch, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.hidebar'),
      "color": _vm.color
    },
    model: {
      value: _vm.urlParams.hidebarSwitch,
      callback: function ($$v) {
        _vm.$set(_vm.urlParams, "hidebarSwitch", $$v);
      },
      expression: "urlParams.hidebarSwitch"
    }
  })], 1), _c('li', [_c('code', [_vm._v("indoor=" + _vm._s(_vm.urlParams.indoorSwitch))]), _vm._v("\n                   \n                  "), _c('div', {
    staticClass: "mt-1 mb-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParams.indoor'))
    }
  }), _c(VSwitch, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.indoor'),
      "color": _vm.color
    },
    model: {
      value: _vm.urlParams.indoorSwitch,
      callback: function ($$v) {
        _vm.$set(_vm.urlParams, "indoorSwitch", $$v);
      },
      expression: "urlParams.indoorSwitch"
    }
  })], 1), _c('li', [_c('code', [_vm._v("pitch=" + _vm._s(_vm.urlParams.pitch))]), _vm._v("\n                   \n                  "), _c('div', {
    staticClass: "mt-1 mb-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParams.pitch'))
    }
  }), _c(VTextField, {
    attrs: {
      "type": "number",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.pitch'),
      "outlined": "",
      "clearable": "",
      "color": _vm.color,
      "rules": [_vm.positiveNumberRule]
    },
    model: {
      value: _vm.urlParams.pitch,
      callback: function ($$v) {
        _vm.$set(_vm.urlParams, "pitch", $$v);
      },
      expression: "urlParams.pitch"
    }
  })], 1), _c('li', [_c('code', [_vm._v("bearing=" + _vm._s(_vm.urlParams.bearing))]), _vm._v("\n                   \n                  "), _c('div', {
    staticClass: "mt-1 mb-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParams.bearing'))
    }
  }), _c(VTextField, {
    attrs: {
      "type": "number",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.bearing'),
      "outlined": "",
      "clearable": "",
      "color": _vm.color,
      "rules": [_vm.positiveNumberRule]
    },
    model: {
      value: _vm.urlParams.bearing,
      callback: function ($$v) {
        _vm.$set(_vm.urlParams, "bearing", $$v);
      },
      expression: "urlParams.bearing"
    }
  })], 1), _c('li', [_c('code', [_vm._v("clusterdistance=" + _vm._s(_vm.urlParams.clusterdistance))]), _vm._v("\n                   \n                  "), _c('div', {
    staticClass: "mt-1 mb-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParams.clusterdistance'))
    }
  }), _c(VTextField, {
    attrs: {
      "type": "number",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.clusterdistance'),
      "outlined": "",
      "clearable": "",
      "color": _vm.color,
      "rules": [_vm.positiveNumberRule]
    },
    model: {
      value: _vm.urlParams.clusterdistance,
      callback: function ($$v) {
        _vm.$set(_vm.urlParams, "clusterdistance", $$v);
      },
      expression: "urlParams.clusterdistance"
    }
  })], 1), _c('li', [_c('code', [_vm._v("zoomlock=" + _vm._s(_vm.urlParams.zoomlock))]), _vm._v("\n                   \n                  "), _c('div', {
    staticClass: "mt-1 mb-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParams.zoomlock'))
    }
  }), _c(VSwitch, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.zoomlock'),
      "color": _vm.color
    },
    model: {
      value: _vm.urlParams.zoomlock,
      callback: function ($$v) {
        _vm.$set(_vm.urlParams, "zoomlock", $$v);
      },
      expression: "urlParams.zoomlock"
    }
  })], 1), _c('li', [_c('code', [_vm._v("zoom=" + _vm._s(_vm.urlParams.zoom))]), _vm._v("\n                   \n                  "), _c('div', {
    staticClass: "mt-1 mb-4",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParams.zoom'))
    }
  }), _c(VTextField, {
    attrs: {
      "type": "number",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.zoom'),
      "outlined": "",
      "clearable": "",
      "color": _vm.color,
      "rules": [_vm.positiveNumberRule]
    },
    model: {
      value: _vm.urlParams.zoom,
      callback: function ($$v) {
        _vm.$set(_vm.urlParams, "zoom", $$v);
      },
      expression: "urlParams.zoom"
    }
  })], 1)])])], 1)], 1), _c(VBtn, {
    class: `mt-6 mt-1 v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.unshareTwin();
      }
    }
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-ban")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.share.unshareButton')) + "\n        ")], 1)] : [_c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.shareTwin();
      }
    }
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-share-alt")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.share.shareButton')) + "\n        ")], 1)]], 2)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };